/**
 * @generated SignedSource<<6689dae41a6fbd0e7df5db50b5dfcb72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarEventCreateScreenQuery$variables = {
  widgetId: string;
};
export type WidgetCalendarEventCreateScreenQuery$data = {
  readonly store: {
    readonly timezone: string;
  };
  readonly widgetCalendarOverview: {
    readonly calendars: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventCreateScreenComponent_storeCalendars">;
    }>;
  } | null;
};
export type WidgetCalendarEventCreateScreenQuery = {
  response: WidgetCalendarEventCreateScreenQuery$data;
  variables: WidgetCalendarEventCreateScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "includeExternal",
    "value": true
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarEventCreateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "widgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CalendarTeamEventCreateScreenComponent_storeCalendars"
              }
            ],
            "storageKey": "calendars(includeExternal:true)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetCalendarEventCreateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "widgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isExternal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              }
            ],
            "storageKey": "calendars(includeExternal:true)"
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14f6a35a6d760700f5c39468c7aa6075",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarEventCreateScreenQuery",
    "operationKind": "query",
    "text": "query WidgetCalendarEventCreateScreenQuery(\n  $widgetId: ID!\n) {\n  widgetCalendarOverview(id: $widgetId) {\n    calendars(includeExternal: true) {\n      ...CalendarTeamEventCreateScreenComponent_storeCalendars\n      id\n    }\n    id\n  }\n  store {\n    timezone\n    id\n  }\n}\n\nfragment CalendarTeamEventCreateScreenComponent_storeCalendars on StoreCalendar {\n  id\n  isExternal\n  ...CalendarTeamEventEditComponent_storeCalendars\n}\n\nfragment CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  isExternal\n}\n\nfragment CalendarTeamEventEditComponent_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  ...CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars\n}\n"
  }
};
})();

(node as any).hash = "b684ea70820fc57545f699cf3a2dff89";

export default node;
